import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7a2fab82")

_pushScopeId("data-v-7a2fab82")
const _hoisted_1 = { class: "flex flex-row items-center gap-x-2" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "w-3 h-3 rounded-full bg-red-lp-100 flex items-center justify-center text-white font-bold text-xs shrink-0" }, " ! ", -1)
const _hoisted_3 = { class: "text-sm font-bold text-gray-lp-300" }
const _hoisted_4 = { class: "flex flex-row items-center gap-x-1.5 text-red-lp-100 text-xs font-semibold" }
const _hoisted_5 = /*#__PURE__*/_createVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 9l-7 7-7-7"
}, null, -1)
const _hoisted_6 = { class: "mt-3" }
const _hoisted_7 = { class: "list-decimal pl-5 text-xs text-gray-lp-300 space-y-0.5 font-normal" }
const _hoisted_8 = { class: "font-bold" }
const _hoisted_9 = { class: "font-bold" }
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = { class: "font-bold" }
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = { class: "mt-4 flex flex-row items-center gap-x-4 overflow-x-auto" }
const _hoisted_14 = { class: "flex flex-row items-start gap-x-3 shrink-0 pr-4 border-r border-gray-lp-1400/40" }
const _hoisted_15 = { class: "relative w-28 h-28 rounded-lg overflow-hidden bg-gray-100 border border-gray-200" }
const _hoisted_16 = { class: "text-11px text-center text-gray-lp-300 leading-tight font-medium" }
const _hoisted_17 = { class: "flex flex-row items-start gap-x-3 overflow-x-auto py-1 pr-2" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "text-base font-bold leading-none" }, "+", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Card = _resolveComponent("Card")!
  const _component_UploadImageTiny = _resolveComponent("UploadImageTiny")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock("div", {
    id: "section-upload-photo",
    class: ["w-full transition-all duration-300 rounded-xl", [_ctx.isShaking ? 'animate-shaking alerts-border' : '']]
  }, [
    _createVNode(_component_Card, {
      rounded: "xl",
      class: "border border-red-lp-100 overflow-hidden p-4 rounded-b-none bg-red-50"
    }, {
      default: _withId(() => [
        _createVNode("div", {
          class: "flex flex-row items-center justify-between cursor-pointer select-none",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleGuide && _ctx.toggleGuide(...args)))
        }, [
          _createVNode("div", _hoisted_1, [
            _hoisted_2,
            _createVNode("h4", _hoisted_3, _toDisplayString(_ctx.title || _ctx.$t("bookingV4.goods.uploadWeight.title")), 1)
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode("span", null, _toDisplayString(_ctx.isOpened
                ? _ctx.$t("bookingV4.goods.uploadWeight.closeGuide")
                : _ctx.$t("bookingV4.goods.uploadWeight.showGuide")), 1),
            (_openBlock(), _createBlock("svg", {
              class: ["w-4 h-4 transform transition-transform duration-200", { 'rotate-180': _ctx.isOpened }],
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _hoisted_5
            ], 2))
          ])
        ]),
        _createVNode(_Transition, { name: "expand" }, {
          default: _withId(() => [
            _withDirectives(_createVNode("div", _hoisted_6, [
              _createVNode("ol", _hoisted_7, [
                _createVNode("li", null, [
                  _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("bookingV4.goods.uploadWeight.guides.resolutionBold")), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingV4.goods.uploadWeight.guides.resolutionText")), 1)
                ]),
                _createVNode("li", null, [
                  _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("bookingV4.goods.uploadWeight.guides.scaleBold")), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingV4.goods.uploadWeight.guides.scaleOrText")) + " ", 1),
                  _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("bookingV4.goods.uploadWeight.guides.volumeBold")), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingV4.goods.uploadWeight.guides.volumeText")), 1)
                ]),
                _createVNode("li", null, [
                  _createVNode("span", _hoisted_11, _toDisplayString(_ctx.$t("bookingV4.goods.uploadWeight.guides.labelSttBold")), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingV4.goods.uploadWeight.guides.labelSttText")), 1)
                ]),
                _createVNode("li", null, [
                  _createVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("bookingV4.goods.uploadWeight.guides.wholePackageBold")), 1),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("bookingV4.goods.uploadWeight.guides.wholePackageText")), 1)
                ])
              ])
            ], 512), [
              [_vShow, _ctx.isOpened]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_Card, {
      rounded: "xl",
      class: "border border-red-lp-100 overflow-hidden p-4 rounded-t-none"
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_13, [
          _createVNode("div", _hoisted_14, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.computedPhotoGuides, (guide, gIdx) => {
              return (_openBlock(), _createBlock("div", {
                key: 'guide-' + gIdx,
                class: "flex flex-col items-center gap-y-1.5 w-28"
              }, [
                _createVNode("div", _hoisted_15, [
                  _createVNode("img", {
                    src: require(`@/app/ui/assets/svg/${guide.source}.svg`),
                    class: "w-full h-full object-cover",
                    alt: "contoh-foto"
                  }, null, 8, ["src"])
                ]),
                _withDirectives(_createVNode("p", _hoisted_16, null, 512), [
                  [_directive_sanitize_html, guide.desc]
                ])
              ]))
            }), 128))
          ]),
          _createVNode("div", _hoisted_17, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.proofPhotos, (photo, index) => {
              return (_openBlock(), _createBlock("div", {
                key: 'upload-' + index,
                class: "shrink-0 proof-photo-box"
              }, [
                _createVNode(_component_UploadImageTiny, {
                  accept: "image/png, image/jpg, image/jpeg",
                  widthContentCard: _ctx.proofPhotos.length > 2 ? 'w-28' : '',
                  titleSize: "10",
                  onUpload: _ctx.onUpload,
                  onRemove: _ctx.onRemove,
                  title: photo.desc,
                  modelValue: _ctx.attachmentImage[index],
                  "onUpdate:modelValue": ($event: any) => (_ctx.attachmentImage[index] = $event),
                  maxSize: 5,
                  watermark: _ctx.watermark,
                  multipleIndex: index,
                  disabled: _ctx.getRulePieceDisabled
                }, null, 8, ["widthContentCard", "onUpload", "onRemove", "title", "modelValue", "onUpdate:modelValue", "watermark", "multipleIndex", "disabled"])
              ]))
            }), 128)),
            (_ctx.proofPhotos.length < _ctx.maxPhoto)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onAddImage && _ctx.onAddImage(...args))),
                  class: "w-6 h-6 rounded-full border-2 border-red-lp-100 text-red-lp-100 flex items-center justify-center hover:bg-red-lp-50 transition-colors shrink-0 ml-1 cursor-pointer self-center",
                  title: _ctx.$t('bookingV4.goods.uploadWeight.addPhoto')
                }, [
                  _hoisted_18
                ], 8, ["title"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    })
  ], 2))
})